import { ChangeDetectionStrategy, Component, effect, inject, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterOutlet } from '@angular/router';
import { FeatureAppShellComponent } from '@iot-platform/feature/app-shell';
import { BuildInfoComponent, SidenavModule } from '@iot-platform/iot-platform-ui';
import { BusinessProfile } from '@iot-platform/models/common';
import { NotificationService } from '@iot-platform/notification';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderComponent } from '../../components/layout/header/header.component';
import { OyanUiRoutingConstants } from '../../oyan-ui.router.constants';
import { AppConfig } from '../../services/config/app.config';
import { APP_CONFIG } from '../../services/config/config.module';

@Component({
  selector: 'oyan-ui-app-shell',
  imports: [
    BuildInfoComponent,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    RouterOutlet,
    SidenavModule,
    TranslatePipe,
    MatTooltipModule,
    HeaderComponent
  ],
  providers: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'mat-mdc-select-bp-overlay-pane' }
    }
  ],
  templateUrl: './app-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppShellComponent extends FeatureAppShellComponent {
  eligibleBusinessProfiles: Signal<BusinessProfile[]> = this.authFacade.eligibleBusinessProfiles;
  appConfig: AppConfig;
  private readonly config: AppConfig = inject(APP_CONFIG);
  private readonly notificationService: NotificationService = inject(NotificationService);

  constructor() {
    super();
    this.appConfig = {
      ...this.config,
      front: { ...this.config.front, version: this.config.front.version },
      back: { ...this.config.back, version: `v-${this.config.back.version}` }
    };
    effect(() => {
      const privileges = this.privileges();
      if (privileges) {
        this.notificationService.hideLoader();
      }
    });
  }

  openMyProfile(): void {
    this.router.navigate([`${OyanUiRoutingConstants.ADMIN}/${OyanUiRoutingConstants.PROFILE}`]);
  }
}
